import Restapi from "../api/Restapi";
import { constats } from "../constant";

export const createInvoice = async (data) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('post',REPORTING_URL+'/apiv1/purchase',data);
}

export const UpdateInvoice = async (id,data) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('put',REPORTING_URL+'/apiv1/purchase/'+id,data);
}

export const DeleteInvoice = async (id) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('delete',REPORTING_URL+'/apiv1/purchase/'+id,null);
}

export const GetAllInvoice = async () => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('get',REPORTING_URL+'/apiv1/purchase',null);
}

export const GetInvoiceByOwnerid = async (ownerid) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('get',REPORTING_URL+'/apiv1/purchase/owner/'+ownerid,null);
}
